import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { smoothlyMenu } from './helpers/helpers';
import $ from 'jquery';
import a4 from '../assets/img/a4.jpg';
import a7 from '../assets/img/a7.jpg';
import profile from '../assets/img/profile.jpg';
import PropTypes from 'prop-types';
import logoTitle from '../assets/img/logo-title-black.png';
import NotificationHeader from './notificationHeader';
import UserProfile from './userProfile';
import { signoutRedirect } from '../services/userService';
import { isMobile } from 'react-device-detect';
import { withContext } from '../helpers/context';

class TopHeader extends Component {
  componentDidMount() {
    if (isMobile) {
      $('body').removeClass('mini-navbar');
    }
  }

  render() {
    return (
      <div className="row border-bottom">
        <nav className="navbar navbar-static-top" role="navigation" style={{ marginBottom: 0 }}>
          <div className="navbar-header">
            <span
              className="navbar-minimalize minimalize-styl-2 btn btn-primary"
              onClick={(e) => this.toggleNavigation(e)}
              style={{ cursor: 'pointer' }}
            >
              <i className="fa fa-bars" />{' '}
            </span>
            <img alt="image" className="logo-title" src={logoTitle}></img>
          </div>
          <ul className="nav navbar-top-links navbar-right">
            <UserProfile />
            {this.props.UserFrom == 'User' && <NotificationHeader />}
            <li>
              <a onClick={this.logout}>
                {' '}
                <i className="fa fa-sign-out" /> Logout
              </a>
            </li>
          </ul>
        </nav>
      </div>
    );
  }

  logout = () => {
    // auth.logout();
    signoutRedirect();
    this.props.history.push('/login');
  };

  toggleNavigation(e) {
    e.preventDefault();
    $('body').toggleClass('mini-navbar');
    smoothlyMenu();
  }
}

TopHeader.propTypes = {
  history: PropTypes.object.isRequired
};

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);
export default withRouter(connect(null, mapDispatchToProps)(withContext(TopHeader)));
